module.exports = __webpack_public_path__ + "static/media/expect.1ba30748.png";